import { types, getSnapshot, applySnapshot } from 'mobx-state-tree';

function getHour() {
  return new Date().getHours() % 12 || 12;
}

function getMinute() {
  return new Date().getMinutes();
}

function getPeriod() {
  return new Date().getHours() >= 12 ? 'PM' : 'AM';
}

export default types
  .model('Time', {
    hour: types.optional(types.number, getHour),
    minute: types.optional(types.number, getMinute),
    period: types.optional(types.enumeration(['AM', 'PM']), getPeriod),
  })
  .actions(self => ({
    setHour(hour) {
      self.hour = hour;
      return self;
    },
    setMinute(minute) {
      self.minute = minute;
      return self;
    },
    setPeriod(period) {
      self.period = period;
      return self;
    },
    setTime(snapshot) {
      applySnapshot(self, snapshot ? { ...getSnapshot(self), ...snapshot } : {});
      return self;
    },
  }));
